import { MY_ACCOUNTS } from './DynamicHeader/Dropdown/DropdownData';

type MoreDropdownProps = {
  activeState: boolean;
  logoutFunction?: () => void;
};

type GeneralDropdownProps = {
  activeState: boolean;
  logoutFunction?: () => void;
  dropdownList?: Array<{ name: string; name_ar: string; link: string }>;
  language?: string;
};

export const MyAccountsDropdown = (props: MoreDropdownProps): JSX.Element => {
  return (
    <div
      className={` ${
        props.activeState ? '' : 'hidden'
      } absolute origin-top-right w-full left-0 rounded-md z-10 focus:outline-none overflow-auto sm:overflow-y-scroll max-h-viewport-75`}
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabIndex={-1}
    >
      <div className="py-1 shadow-lg bg-white  sm:shadow-none" role="none">
        {MY_ACCOUNTS.map((ele: { name: string; link: string }) => (
          <a
            href={ele.link}
            target="_blank"
            className="text-s-14 font-semibold text-font-500 block px-6 py-3 font-md text-sm  hover:bg-[#F4F9FF] sm:hover:bg-white"
            role="menuitem"
            tabIndex={-1}
            key={ele.name}
            id={`menu-item-${ele.name}`}
            rel="noreferrer"
          >
            {ele.name}
          </a>
        ))}
        <a
          href="#"
          className="text-s-14 font-semibold text-font-500 block px-6 py-3 font-md cursor-pointer text-sm hover:bg-[#F4F9FF] sm:hover:bg-white"
          role="menuitem"
          tabIndex={-1}
          key="logout"
          id="menu-item-0"
          onClick={props.logoutFunction}
        >
          Logout
        </a>
      </div>
    </div>
  );
};

export const GeneralDropdown = ({
  activeState,
  dropdownList,
  language = 'English',
}: GeneralDropdownProps): JSX.Element => {
  return (
    <div
      className={` ${
        activeState ? '' : 'hidden'
      } origin-top-right absolute z-10 left-5 pt-2 w-56 focus:outline-none sm:relative sm:w-full sm:left-0 sm:pl-8 sm:overflow-y-scroll max-h-viewport-75`}
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabIndex={-1}
    >
      <div
        className="py-1 rounded-md shadow-lg   sm:shadow-none bg-white"
        role="none"
      >
        {Array.isArray(dropdownList) &&
          dropdownList?.map(
            (ele: { name: string; name_ar: string; link: string }) => (
              <a
                href={ele.link}
                target="_blank"
                className="text-gray-700 block px-4 py-4 font-md text-sm hover:bg-grey-175 sm:hover:bg-white"
                role="menuitem"
                tabIndex={-1}
                key={ele.name}
                id={`menu-item-${ele.name}`}
                rel="noreferrer"
              >
                {language === 'Arabic' ? ele.name_ar : ele.name}
              </a>
            )
          )}
      </div>
    </div>
  );
};

export const GeneralMobileDropdown = ({
  activeState,
  dropdownList,
  language = 'English',
}: GeneralDropdownProps): JSX.Element => (
  <div
    className={` ${
      activeState ? '' : 'hidden'
    } origin-top-right absolute z-10 left-5 pt-2 w-56 focus:outline-none sm:absolute sm:w-full sm:left-0 sm:overflow-y-scroll max-h-viewport-75`}
    role="menu"
    aria-orientation="vertical"
    aria-labelledby="menu-button"
    tabIndex={-1}
  >
    <div
      className="py-1 rounded-md shadow-lg   sm:shadow-none bg-white"
      role="none"
    >
      {dropdownList &&
        dropdownList.map(
          (ele: { name: string; name_ar: string; link: string }) => (
            <a
              href={ele.link}
              target="_blank"
              className="text-gray-700 block px-4 py-4 font-md text-sm hover:bg-grey-175 sm:hover:bg-white"
              role="menuitem"
              tabIndex={-1}
              key={ele.name}
              id={`menu-item-${ele.name}`}
              rel="noreferrer"
            >
              {language === 'Arabic' ? ele.name_ar : ele.name}
            </a>
          )
        )}
    </div>
  </div>
);
